// Libs
import _ from 'lodash'

const resetMiddleware = store => next => action => {
  if(action.type === '@@router/LOCATION_CHANGE') {
    const state = store.getState()

    const localLoading = state.app.localLoading
    const pageLoading = state.app.pageLoading
    const tip = state.app.tip
    const err = state.app.err
    const success = state.app.success
    const upload = state.app.upload
    const download = state.app.download
    const cities = state.app.cities
    const lawyer = state.newInvitationPage.lawyer
    const spCase = state.spCasePage.spCase
    const checkout = state.spCasePage.checkout

    // Scroll to the top of the page
    // Try catch cause some browser versions don't allow window.scroll
    try {
      window.scroll({
        top: 0,
        left: 0
      })
    }
    catch(err) {
      console.log(err)
    }

    if(localLoading) {
      next({ type: 'change_local_loading', payload: false })
    }
    if(pageLoading) {
      next({ type: 'change_page_loading', payload: false })
    }
    if(tip) {
      next({ type: 'change_tip', payload: ''})
    }
    if(err) {
      next({ type: 'change_err', payload: '' })
    }
    if(success) {
      next({ type: 'change_success', payload: '' })
    }
    if(upload.progress !== 0) {
      next({ type: 'change_upload', payload: { spCaseId: '', progress: 0, total: 1, err: false }})
    }
    if(download.progress !== 0) {
      next({ type: 'change_download', payload: { spCaseId: '', fileRequest: '', progress: 0, total: 1, err: false }})
    }
    if(!_.isEmpty(cities)) {
      next({ type: 'change_cities', payload: [] })
    }
    if(!_.isEmpty(lawyer)) {
      next({ type: 'change_lawyer', payload: {} })
    }
    if(!_.isEmpty(spCase.chat)) {
      next({ type: 'change_sp_case', payload: { chat: [], client: {}, lawyer: {}, company: {}, group: {}, classifiers: [] }})
    }
    if(checkout) {
      next({ type: 'change_checkout', payload: false })
    }
  }

  next(action);
}

export default resetMiddleware
